import React from "react";
import { firestore } from "../../../config/firebase";
import { collection, doc, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, message } from "antd";
import { useAuthContext } from "../../../contexts/AuthContext";
import { Helmet } from "react-helmet-async";

export default function Page() {
    const Navigate = useNavigate()
    const params = useParams()
    const [course, setcourse] = useState({})
    const [isProcessing, setIsProcessing] = useState(false)

    const { user, isAuth } = useAuthContext()

    const registerCourse = async () => {
        setIsProcessing(true);

        if (!isAuth) {
            message.error("First Login, then you will be able to register in the Course");
            setIsProcessing(false); // Set isProcessing to false here
            return Navigate("/auth/login");
        }

        try {
            const enrolledCourses = await getEnrolledCourses();

            const isAlreadyEnrolled = enrolledCourses.some((courses) => courses.courseId === course.courseId);

            if (isAlreadyEnrolled) {
                message.error("You are already Enrolled in this course");
            } else {
                const enrollmentId = Math.random().toString(36).slice(2);
                const courses = {
                    courseId: course.courseId,
                    courseName: course.title,
                    coursePrice: course.price,
                    courseDuration: course.duration,
                    enrolledBy: user.uid,
                    enrolledName: user.fullName,
                    userWhatsappNumber: user.phoneNumber,
                    userPhoneNumber: user.whatsappNumber,
                    enrolledAt: new Date().toLocaleString(),
                    enrollmentId: enrollmentId,
                    status: "active",
                };

                await setDoc(doc(firestore, "registeredCourses", enrollmentId), courses);
                message.success("You are registered successfully");
            }
        } catch (error) {
            message.error("Something went wrong while Register. Please contact us.");
            console.error("Error: ", error);
        } finally {
            setIsProcessing(false); // Set isProcessing to false after try-catch
        }
    };
    const getEnrolledCourses = async () => {
        const q = query(collection(firestore, 'registeredCourses'), where('enrolledBy', '==', user.uid));
        const querySnapshot = await getDocs(q);
        const array = [];
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            array.push(data);
        });
        // setEnrolledCourses(array);
        return array

    }
    useEffect(() => {
        const getcourse = async () => {
            try {
                const docRef = doc(firestore, "courses", params.courseId);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setcourse(data);
                } else {
                    console.log("No such document!");
                }
            } catch (error) {
                console.error(error);
            }
        };

        getcourse();
    }, [params.courseId])

    return (
        <>
            <Helmet>
                <title>Quran Course, dive into Islam </title>
                <meta name="description" content="Courses: Discover our Quranic programs. From Tajweed to Tafseer, enrich your knowledge. Join us on your Quranic journey" />
                <link rel="canonical" href="https://www.ilmulquran.online/courses/" />
            </Helmet>
            <div className="mt-24 text-[#fffa8a]">
                <h1 className="text-[45px] underline text-center italic ">{course.title} </h1>
                <h2 className=" text-[#fffa8a] p-8 md:px-80 sm:px-40 opacity-70 text-[25px] mt-4 "><span className="underline">Category</span> : {course.category}</h2>
                <h1 className="text-[35px] px-8 md:px-80 sm:px-40  underline  italic inline">
                    Description:-

                </h1>
                <p className="text-[#fffa8a] mt-2 px-8 md:px-80 sm:px-40 text-[20px] ">
                    {course.description && course.description.split(/\\+/).map((part, index) => (
                        <span key={index}>
                            {part}
                            {index !== course.description.split(/\\+/).length - 1 && <br />}
                        </span>
                    ))}
                </p>

                <h2 className=" text-[#fffa8a] px-8 md:px-80 sm:px-40  text-[25px] mt-4 "><span className="underline">Duration</span> : {course.duration}</h2>
                <h2 className=" text-[#fffa8a] px-8 md:px-80 sm:px-40  text-[25px] font-mono mt-2 "><span className="underline">Price</span> : {course.price}</h2>
                <div className="flex justify-content-center mt-9">
                    <Button
                        htmlType='submit'
                        className='px-10 flex text-2xl pt-2 pb-11 mx-auto text-center rounded-2xl hover:rounded-lg'
                        style={{ background: "transparent", border: "1px solid #fffa8a", color: "#fffa8a" }}
                        onClick={registerCourse} loading={isProcessing}
                    >
                        Register Yourself
                    </Button>

                </div>
            </div>
        </>
    );
}
